"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LlmGeneralExerciseHandler = void 0;
const AbstractExerciseHandler_1 = require("@app/routes/SpeechDevelopment/handlers/AbstractExerciseHandler");
const audioPlayer_1 = require("@app/services/audioPlayer");
const exercise_js_1 = require("@app/routes/SpeechDevelopment/reducers/exercise.js");
const timer_1 = require("../timer");
const llmGeneralStep_1 = require("@app/services/llmGeneralStep");
const _params_1 = require("@params");
const playBlob_1 = require("@app/services/playBlob");
class LlmGeneralExerciseHandler extends AbstractExerciseHandler_1.AbstractExerciseHandler {
    constructor() {
        super(...arguments);
        this.attemptMaxNumber = 12;
        this.coverageThresholds = {
            correct: 0.9,
        };
    }
    get isLast() {
        return this.currentIndex === this.data.length - 1;
    }
    get isFirst() {
        return this.currentIndex === 0;
    }
    playCurrentQuestion() {
        return __awaiter(this, void 0, void 0, function* () {
            yield audioPlayer_1.audioPlayer.stopAudio();
            yield audioPlayer_1.audioPlayer.playAudio(null, this.current.full_question_audio);
        });
    }
    handleAnswer(coverage) {
        return __awaiter(this, void 0, void 0, function* () {
            const isCorrect = this.checkIsCorrectAnswer(coverage);
            if (isCorrect) {
                yield this.handleCorrectAnswer();
            }
            else
                yield this.handleWrongAnswer();
            return isCorrect;
        });
    }
    checkIsCorrectAnswer(coverage) {
        return coverage >= this.coverageThresholds.correct;
    }
    handleCorrectAnswer() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            (0, timer_1.stopTimer)();
            const nextId = !this.isLast ? (_a = this.data[this.currentIndex + 1]) === null || _a === void 0 ? void 0 : _a.id : undefined;
            this.trackRepEnd(true, nextId);
            this.updateAnswers({ isCorrect: true, isChecked: true, id: this.current.id });
            yield this.addCoin();
            if (!this.isLast) {
                this.dispatch((0, exercise_js_1.setCurrentIndex)(this.currentIndex + 1));
                this.dispatch((0, exercise_js_1.resetRecognizedWords)());
            }
            else {
                this.stopExercise();
            }
        });
    }
    handleWrongAnswer(timeIsOver) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            audioPlayer_1.audioPlayer.stopAudio();
            if (this.recognizedWords.length + 1 === this.attemptMaxNumber || timeIsOver) {
                if (!timeIsOver)
                    (0, timer_1.stopTimer)();
                const nextId = !this.isLast ? (_a = this.data[this.currentIndex + 1]) === null || _a === void 0 ? void 0 : _a.id : undefined;
                this.trackRepEnd(false, nextId);
                this.updateAnswers({ isCorrect: false, isChecked: true, id: this.current.id });
                yield audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(this.langId, 'super'));
                if (this.isLast) {
                    this.stopExercise();
                    return;
                }
                this.dispatch((0, exercise_js_1.setCurrentIndex)(this.currentIndex + 1));
                this.dispatch((0, exercise_js_1.resetRecognizedWords)());
            }
        });
    }
    handleRecognized({ text, dialogueFlow }) {
        return __awaiter(this, void 0, void 0, function* () {
            const { coverage, comment, isLastAttempt } = yield this.processLlm(dialogueFlow);
            this.dispatch((0, exercise_js_1.setRecognizedWords)([...this.recognizedWords, text]));
            return { coverage, comment, isLastAttempt };
        });
    }
    handleTimerOut() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isChecked && !this.answers[this.currentIndex])
                yield this.handleWrongAnswer();
        });
    }
    processLlm(dialogueFlow) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = {
                picture_description: this.current.right_word || '',
                dialogue_flow: dialogueFlow,
                lang_id: Number(this.langId),
                need_tts: true,
            };
            console.log('sending llm request');
            const { coverage, comment, blob } = yield (0, llmGeneralStep_1.llmGeneralStepAudio)(_params_1.host, body);
            const isLastAttempt = this.recognizedWords.length + 1 >= this.attemptMaxNumber;
            let resComment = comment;
            if (blob && !isLastAttempt && coverage < this.coverageThresholds.correct) {
                yield (0, playBlob_1.playBlob)(blob);
            }
            else {
                resComment = '';
            }
            return { coverage, comment: resComment, isLastAttempt };
        });
    }
    nextCard() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isLast)
                return;
            (0, timer_1.stopTimer)();
            this.trackRepEnd(false, (_a = this.data[this.currentIndex + 1]) === null || _a === void 0 ? void 0 : _a.id);
            this.updateAnswers({ isCorrect: false, isChecked: true, id: this.current.id });
            this.dispatch((0, exercise_js_1.setCurrentIndex)(this.currentIndex + 1));
        });
    }
    previousCard() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isFirst)
                return;
            (0, timer_1.stopTimer)();
            this.dispatch((0, exercise_js_1.setCurrentIndex)(this.currentIndex - 1));
            this.dispatch((0, exercise_js_1.setAnswers)(this.answers.slice(0, this.answers.length - 1)));
        });
    }
    stopExercise() {
        (0, timer_1.stopTimer)();
        this.dispatch((0, exercise_js_1.setIsSFinished)(true));
        audioPlayer_1.audioPlayer.stopAudio();
        window.stopExercise(true, true, this.exerciseInfo.id);
        this.sendExerciseReport(this.exerciseInfo.number || this.exerciseInfo.id, this.answers);
    }
    stop() {
        audioPlayer_1.audioPlayer.stopAudio();
        (0, timer_1.stopTimer)();
    }
}
exports.LlmGeneralExerciseHandler = LlmGeneralExerciseHandler;
